const { __ } = wp.i18n;

class DisableCopy {
	init() {
		const _this = this;

		document.onkeypress = (event) => {
			return _this.hasAllowed(event);
		};

		document.onmousedown = (event) => {
			return _this.hasAllowed(event);
		};

		document.onkeydown = function (event) {
			return _this.hasAllowed(event);
		};

		// Disable right click.
		document.addEventListener('contextmenu', (event) => {
			event.preventDefault();
			_this.alertCopyNotAllowed();
		});
	}

	hasAllowed(event) {
		const _this = this;
		const _event = event || window.event;
		const ctrlDown = _event.ctrlKey || _event.metaKey;
		const keyCode = _event.keyCode;
		const keys = [
			123, // F12
			65, // ctrl+a
			67, // ctrl+c
			85, // ctrl+u
		];

		let result = true;
		keys.forEach((key) => {
			if (123 === keyCode || (ctrlDown && key === keyCode)) {
				_this.alertCopyNotAllowed();
				keys.length = 0;
				result = false;
			}
		});

		return result;
	}

	alertCopyNotAllowed() {
		// eslint-disable-next-line no-alert
		window.alert(__('Unauthorized copying of content.', 'gaz_assets'));
	}
}

if ('true' !== gazApp.logged_in) {
	new DisableCopy().init();
}
